import { Box, Button, Divider, FormControl, MenuItem, Typography } from "@mui/material";
import Calendar from "../../../components/common/Calendar"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { fetchAllSlots, selectAllEvents, selectSlotsLoading } from "../../../slices/slotManagement";
import moment from "moment";
import { convertSlotsToEvents } from "../../../utils/generic/function";
import { selectAllLocation } from "../../../slices/common";
import SelectField from "../../../components/styled/SelectField";
import { SpinnerLoader } from "../../../../assets/loader/loader";

const CalendarModel = ({ rageDate, handleSelectedSlot, actionValues, handleCloseModal, disabledAction = false, allPreferredDate=[] }) => {
    const location = actionValues?.manufacturing_id
    const dispatch = useDispatch()
    const [startStr, endStr] = rageDate.split(" - ");
    const allLocation = useSelector(selectAllLocation)
    const allEvents = useSelector(selectAllEvents)
    const [slotType, setSlotType] = useState("all")
    const calendarRef = useRef(null);
    const isLoading = useSelector(selectSlotsLoading)
    const visibleRange = {
        start: moment(new Date(startStr)).format("YYYY-MM-DD"),
        end: moment(new Date(endStr)).add(1, 'day').format("YYYY-MM-DD"),
    }
    const setInitialDates = () => {
        const calendarApi = calendarRef.current?.getApi();
        if (calendarApi && visibleRange) {
            const adjustedEnd = moment(visibleRange.end).add(1, 'day').format("YYYY-MM-DD");
            calendarApi.select(visibleRange.start, adjustedEnd);
        }
    }

    const fetchEvents = async () => {
        await dispatch(fetchAllSlots({ location_id: location, slot_type: slotType }))
    }

    useEffect(() => {
        fetchEvents()
        setInitialDates()
    }, [slotType, location])
    // Convert both slot events and preferred dates to calendar events
    const slotEvents = location ? convertSlotsToEvents(allEvents, allPreferredDate) : [];
    const formOptions = [
        {
            type: 'select',
            name: 'location_id',
            placeholder: 'Select any location',
            options: allLocation?.items?.map(op => ({ value: op.id, label: op.name }))
        },
        {
            type: 'select',
            name: 'slot_type',
            placeholder: 'Select any type',
            options: [
                { value: "all", label: "All Slots" },
                { value: "available", label: "Available" },
                { value: "request", label: "Requested" },
                { value: "booked", label: "Booked" },
            ]
        },
    ]
    return <div>
        <Box className="flex justify-content-between align-items-center p-2 relative bg-white">
            <div>
                <Typography variant="h6">Select Slots</Typography>
            </div>
            <form className="flex  gap-2 align-items-center" >
                <FormControl variant={"standard"}>
                    <div className="w-100 flex gap-2 align-items-center">
                        <SelectField
                            value={location}
                            disabled={disabledAction}
                            onChange={(e) => {
                                handleSelectedSlot(null, null, null, e.target.value)
                            }}
                            sx={{
                                '& .MuiSelect-select span::before': {
                                    color: '#808080',
                                    content: `"${formOptions[0].placeholder || '-- Select --'}"`,
                                },
                            }}
                        >
                            <MenuItem value=""><em>{formOptions[0].placeholder || 'Select'}</em></MenuItem>
                            {formOptions[0]?.options?.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </SelectField>
                        <SelectField
                            value={slotType}
                            onChange={(e) => {
                                setSlotType(e.target.value)
                            }}
                            sx={{
                                '& .MuiSelect-select span::before': {
                                    color: '#808080',
                                    content: `"${formOptions[1].placeholder || '-- Select --'}"`,
                                },
                            }}

                        >
                            <MenuItem value=""><em>{formOptions[1].placeholder || 'Select'}</em></MenuItem>
                            {formOptions[1].options.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </SelectField>
                    </div>
                </FormControl>
            </form>
        </Box>
        <div className="bg-white">
            <Divider className="ml-2 mr-2" />
        </div>
        {isLoading ? (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="60vh"
            >
                <SpinnerLoader />
            </Box>) :
            <Calendar
                setInitialDates={setInitialDates}
                calendarRef={calendarRef}
                visibleRange={visibleRange}
                selectedSlot={actionValues?.slot_id}
                location={allLocation?.items?.find(op => op.id == location)?.name}
                handleSelectedSlot={handleSelectedSlot}
                allEvents={slotEvents} // Combine both events safely
                allPreferredDate={allPreferredDate}
            />}
        <div className="text-center">
            <Button onClick={() => handleCloseModal()}>
                Confirm
            </Button>
        </div>
    </div>
}

export default CalendarModel;